import React, { useEffect, useState } from 'react';

const EscalatedQueries = ({ data = [] }) => { 
    const [escalation, setEscalation] = useState([]);

    useEffect(() => {
        setEscalation(Array.isArray(data) ? data : []);
    }, [data]);


    return (
        <div className='shadow-custom rounded-3xl p-5 w-full lg:w-1/3'>
            <p className='text-base font-semibold text-black'>Escalated Queries</p>
            <div className='flex flex-row justify-between mt-7 border-b-2 border-gray-100 py-3'>
                <p className='text-sm font-medium text-gray-400'>Timeframe</p>
                <p className='text-sm font-medium text-gray-400'>Escalated Queries</p>
            </div>
            {escalation.length > 0 ? (
                escalation.map((esca, index) => (
                    <div key={index} className='flex flex-row justify-between mt-2 border-b-2 border-gray-100 py-3'>
                        <p className='text-base font-semibold text-gray-500'>{esca.month}</p>
                        <p className='text-base font-semibold text-gray-500'>{esca.escalated_cases}</p>
                    </div>
                ))
            ) : (
                <p className="text-center text-gray-400 mt-4">No escalation data available</p>
            )}
        </div>
    );
}

export default EscalatedQueries;
